/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popLuckylotteryItems.vue?vue&type=template&id=67c8fa3a&scoped=true"
import script from "./popLuckylotteryItems.vue?vue&type=script&lang=js"
export * from "./popLuckylotteryItems.vue?vue&type=script&lang=js"
import style0 from "./popLuckylotteryItems.vue?vue&type=style&index=0&id=67c8fa3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c8fa3a",
  null
  
)

export default component.exports